import config from '../config';

export const getDefaultState = () => ({
	homePage: 'report-list',
	clientId: 'adminApp',
	scopeName: 'DriverScope',
	sidebarUserLinks: config.sidebarUserLinks,
	refreshTokenLoading: false,
	isLoginActive: false,
	currentUser: {
		name: '',
		surname: '',
		email: '',
		roles: [],
	},
	formChanged: false,
	loginError: null,
	versionInfo: null,
	reservationFilter: {
		isExpired: null,
		region: null,
		county: null,
		city: null,
		street: null,
		Status: null,
		isPostPackage: null,
		ReservationNumberLike: null,
		Phone: null,
		From: null,
		To: null,
		Email: null,
		orderBy: null,
		direction: null,
	},
	reservationSelects: [],
	reportFilter: {
		name: null,
		note: null,
		isActive: true,
		containers: [],
		orderBy: null,
		direction: null,
	},
});

export const state = getDefaultState();
